/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Pricing_Meta_TitleInputs */

const ja_playdata_pricing_meta_title = /** @type {(inputs: Playdata_Pricing_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プラン・価格`)
};

const en_playdata_pricing_meta_title = /** @type {(inputs: Playdata_Pricing_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pricing`)
};

/**
* | output |
* | --- |
* | "Pricing" |
*
* @param {Playdata_Pricing_Meta_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_pricing_meta_title = /** @type {((inputs?: Playdata_Pricing_Meta_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Pricing_Meta_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_pricing_meta_title(inputs)
	return en_playdata_pricing_meta_title(inputs)
});